if ($('#store-locator-title').length) {
 $b.addClass('dealer-locator');
}